/**
 * spec-variant-swap.js
 * OUPINKE Watch Specifications — Variant Swap
 * Added: Watch Spec Update 5th July
 *
 * Listens for Shopify's native variant change event.
 * Reads the embedded JSON data island and updates all
 * variant-specific spec rows without any AJAX requests.
 */

(function () {
  'use strict';

  const DATA_ISLAND_ID = 'spec-variant-data';
  const ROW_SELECTOR   = '[data-spec-row]';
  const FIELD_ATTR     = 'data-variant-field';
  const VALUE_SELECTOR = '.spec-table__value-text';

  /**
   * Parse the variant data island once on load.
   * Returns null if the island is not present on this page.
   */
  function getVariantData() {
    const el = document.getElementById(DATA_ISLAND_ID);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[spec-variant-swap] Failed to parse variant data:', e);
      return null;
    }
  }

  /**
   * Update all variant-specific spec rows for the given variant ID.
   */
  function updateSpecRows(variantId, variantData) {
    const data = variantData[variantId];
    if (!data) return;

    const rows = document.querySelectorAll(ROW_SELECTOR);

    rows.forEach(function (row) {
      const fieldKey   = row.getAttribute(FIELD_ATTR);
      const valueEl    = row.querySelector(VALUE_SELECTOR);
      const fieldValue = data[fieldKey] || '';

      if (!valueEl) return;

      if (fieldValue && fieldValue !== '') {
        valueEl.textContent = fieldValue;
        row.style.display   = '';
      } else {
        // Hide the row if this variant has no value for this field
        row.style.display = 'none';
      }
    });
  }

  /**
   * Initialise — attach event listeners once DOM is ready.
   */
  function init() {
    const variantData = getVariantData();
    if (!variantData) return;

    // Dawn dispatches 'variant:change' on the variant selector element
    // and also updates the URL — we listen on the document for safety
    document.addEventListener('variant:change', function (event) {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;
      updateSpecRows(String(variant.id), variantData);
    });

    // Fallback: also listen for Shopify's older 'change' event on
    // the variant select / radio inputs used by Dawn
    document.addEventListener('change', function (event) {
      const target = event.target;
      if (
        target.matches('[name="id"]') ||
        target.closest('variant-selects') ||
        target.closest('variant-radios')
      ) {
        const variantId = target.value || (
          target.closest('form') &&
          target.closest('form').querySelector('[name="id"]') &&
          target.closest('form').querySelector('[name="id"]').value
        );
        if (variantId) {
          updateSpecRows(String(variantId), variantData);
        }
      }
    });
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
